module.exports = __webpack_public_path__ + "15d46125.svg";